import { createFormContext } from '@mantine/form'
import { WebhookBuilderFormDataState } from 'components/business/Integration/BuilderModal/type'

export const [WebhookBuilderFormProvider, useWebhookBuilderFormContext, useWebhookBuilderForm] =
  createFormContext<WebhookBuilderFormDataState>()
